import React from 'react';
import { shape, string, func, oneOfType, number } from 'prop-types';

// Import styles
import { ListItem } from './styles';

const SettingItem = ({ item, onSelect, selected }) => {
	const { value, name } = item;
	const isSelected = value === selected;
	const handleItemSelect = () => onSelect(item);

	return (
		<ListItem onClick={handleItemSelect} isSelected={isSelected}>
			{name}
		</ListItem>
	);
};

SettingItem.propTypes = {
	item: shape({
		value: oneOfType([string, number]).isRequired,
		name: string.isRequired
	}),
	onSelect: func.isRequired,
	selected: oneOfType([string, number]).isRequired
};

export default SettingItem;
